import { render } from "./Checkbox.vue?vue&type=template&id=691a4711&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=691a4711&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-691a4711"

export default script